export type PriceLike = {
    currency: string;
    amount: number;
};

export type FormattedPrice = {
    currency: string;
    amount: string;
};

/**
 * Formats a price into separate currency symbol and amount strings for layout.
 *
 * Locale is fixed to en-GB so symbols stay disambiguated (e.g. US$, JP¥) rather than
 * collapsing to bare $ / ¥ under en-US or the runtime locale.
 */
export function formatPrice(price: PriceLike | undefined): FormattedPrice | undefined {
    if (!price) {
        return undefined;
    }

    try {
        const parts = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: price.currency,
        }).formatToParts(price.amount);

        const currency =
            parts.find((part) => part.type === "currency")?.value ?? price.currency;
        const amount = parts
            .filter((part) => part.type !== "currency")
            .map((part) => part.value)
            .join("")
            .trim();

        return { currency, amount };
    } catch {
        return {
            currency: price.currency,
            amount: String(price.amount),
        };
    }
}
